import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/app/src/modules/register/register-form/register-form.tsx");
